import { themr } from '@friendsofreactjs/react-css-themr';
import identifiers from 'components/identifiers';
import StringList from './StringList';

export default themr(identifiers.StringList)(StringList);
